/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IApiList, IEmployeePayrollTip } from 'types';
import { EmployeePayrollTips } from './types';

const initialState: IApiList<IEmployeePayrollTip> | null = null;

export const employeePayrollTipsReducer: Reducer<IApiList<IEmployeePayrollTip> | null> = (state = initialState, action) => {
  switch (action.type) {
    case EmployeePayrollTips.GET_EMPLOYEE_PAYROLL_TIPS_SUCCESS:
    case EmployeePayrollTips.GET_PAY_PERIOD_PAYROLL_TIPS_SUCCESS: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};
